module.exports = "/build/web/images/banner/banner-mobile.f9ef5e5844b485fe368fd123848564d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/banner/banner-mobile.jpg
// module id = 118
// module chunks = 24